// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.pr-m-wrapper {
  padding: 24px;
}

.pr-m-wrapper .pr-header-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.pr-m-wrapper .pr-header {
  font-size: 2rem;
  font-weight: 600;
  font-family: Poppins;
}

.pr-m-wrapper .pr-outer-table {
  margin-right: 0;
  margin-left: 0;
  border-radius: 5px;
  border: 1px solid #dee2e6;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  padding: 20px 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.pr-m-wrapper .table {
  font-family: Poppins;
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: #dee2e6;
  caption-side: bottom;
  border-collapse: collapse;
  font-size: 14px;
  min-width: 1300px;
}

.table > thead {
  vertical-align: bottom;
}

.table > tbody {
  vertical-align: inherit;
}

tbody,
td,
tfoot,
th,
thead,
tr {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

.table > :not(caption) > * > * {
  padding: 10px 15px;
  color: #000;
  background-color: #fff;
  border-bottom: 1px solid #dee2e6;
  text-align: left;
}

.table tr th {
  white-space: nowrap;
}

.filter-cb {
  margin-bottom: 20px;
  line-height: 1;
  display: flex;
  align-items: center;
  gap: 15px;
}

.filter-cb .bordered-button {
  padding: 8px 16px;
}

.filter-cb label {
  line-height: 1;
  font-size: 14px;
}

.filter-cb .input-set input {
  padding: 10px 15px;
  border: 1px solid #dee2e6;
}

.filter-cb .input-set input:hover {
  border: 1px solid #dee2e6;
}
`, "",{"version":3,"sources":["webpack://./src/features/corporate-enquiry/corporate-enquiry.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;;;EAME,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.pr-m-wrapper {\n  padding: 24px;\n}\n\n.pr-m-wrapper .pr-header-container {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.pr-m-wrapper .pr-header {\n  font-size: 2rem;\n  font-weight: 600;\n  font-family: Poppins;\n}\n\n.pr-m-wrapper .pr-outer-table {\n  margin-right: 0;\n  margin-left: 0;\n  border-radius: 5px;\n  border: 1px solid #dee2e6;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n  padding: 20px 0;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.pr-m-wrapper .table {\n  font-family: Poppins;\n  width: 100%;\n  margin-bottom: 1rem;\n  vertical-align: top;\n  border-color: #dee2e6;\n  caption-side: bottom;\n  border-collapse: collapse;\n  font-size: 14px;\n  min-width: 1300px;\n}\n\n.table > thead {\n  vertical-align: bottom;\n}\n\n.table > tbody {\n  vertical-align: inherit;\n}\n\ntbody,\ntd,\ntfoot,\nth,\nthead,\ntr {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n.table > :not(caption) > * > * {\n  padding: 10px 15px;\n  color: #000;\n  background-color: #fff;\n  border-bottom: 1px solid #dee2e6;\n  text-align: left;\n}\n\n.table tr th {\n  white-space: nowrap;\n}\n\n.filter-cb {\n  margin-bottom: 20px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.filter-cb .bordered-button {\n  padding: 8px 16px;\n}\n\n.filter-cb label {\n  line-height: 1;\n  font-size: 14px;\n}\n\n.filter-cb .input-set input {\n  padding: 10px 15px;\n  border: 1px solid #dee2e6;\n}\n\n.filter-cb .input-set input:hover {\n  border: 1px solid #dee2e6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
